module.exports = __webpack_public_path__ + "images/c12dbdd241712fe0589692dbd686496a099c5b4370d24fc92047ccc27f698128.svg";